import { useParams } from 'react-router-dom';
import { PerformanceReportPage } from '../PerformanceReportPage';
import { DataExplorerReport } from './DataExplorerReport';
import { DATA_EXPLORER } from '@diana/core';

export const PerformanceReportRedirector = () => {
  const { reportId } = useParams<{ reportId: string }>();

  if (!reportId) throw new Error(`reportId is missing [PerformanceReportRedirector]`);

  return reportId === DATA_EXPLORER ? (
    <DataExplorerReport />
  ) : (
    <PerformanceReportPage key={reportId} reportId={reportId} />
  );
};

export const Component = PerformanceReportRedirector;
